import React,{useEffect, useState} from "react";
import { useHistory } from "react-router";
import demologo from "../../../assets/demologo.png";
import success from "../../../assets/bookdemo/ezgif.com-gif-maker.gif";
import calender from "../../../assets/bookdemo/Calender.png";
import time from "../../../assets/bookdemo/filing time.png";
import moment from 'moment';
import { slotFormatAMPM, overlapUTCtimeConverter, formatTimeslot } from "../../../helpers/TimeDate";
import { initGA } from "../../../helpers/CampaignEvents";

const SuccessMessage = () => {
  
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const demoTime = JSON.parse(localStorage.getItem("DEMO_TIME"));
  const demoDate = JSON.parse(localStorage.getItem("DEMO_DATE"));
  const history = useHistory();
  const dateformat = moment(demoDate?demoDate:new Date()).format("ddd Do, MMMM  ")
  const [date, setDate] = useState("");
  // const time = slotFormatAMPM(demoTime.timeView);
  const demoUser = JSON.parse(localStorage.getItem("DEMOUSER"));
  localStorage.setItem("USER", JSON.stringify(demoUser));
  useEffect(() => {
    initGA()
    setDate(dateformat)
    window. gtag('event', 'conversion', {
      'send_to': 'AW-312869085/mO73CLaoqowDEN2BmJUB',
      'transaction_id': ''
  });
  }, [])


  const dashBoard = () =>{
    localStorage.removeItem("DEMO_SESSION")
    localStorage.removeItem("DEMO_TIME")
    localStorage.removeItem("DEMOUSER")
    localStorage.removeItem("DEMO_DATE")
    localStorage.removeItem("DEMO_DATE")
    history.push("/dashboard")
  }
  

  return (

          <div className="demo-success">
            <div className="mb-2">
              <img
                width="122px"
                height="32px"
                src={demologo}
                alt="clapingologo"
              />
            </div>
            <p className="headingfont">Congratulations!</p>
            <p className="subtitle">Trial Booked.</p>
            <img src={success} className="success-img" alt="demo booked" />
            <div className="demo-details mt-4">
              <p className="trial-heading">
                <strong>15 min.</strong> Trial Details
              </p>
              <div className="d-flex">
                <img
                  src={calender}
                  width={24}
                  height={24}
                  className="img-fluid"
                  alt="calender-img"
                />
                <p className="my-auto ml-3">{dateformat}</p>
              </div>
              <div className="d-flex mt-3">
                <img
                  src={time}
                  width={24}
                  height={24}
                  className="img-fluid"
                  alt="calender-img"
                />
                <p className="my-auto ml-3">{slotFormatAMPM(`${overlapUTCtimeConverter(demoTime?.startTime)} - ${overlapUTCtimeConverter(demoTime?.endTime)}`)}</p>
              </div>
            </div>
            <div className="instruction mt-4">
              <p>Instructions:</p>
              <ol>
                <li>
                 You will receive joining details over whatsapp/email. 
                </li>
                <li>
                 Please make sure you have stable internet connection.
                </li>
                <li>
                Please join the session on time. We ensure you a great experience.
                </li>
              </ol>
            </div>

            <button type="submit" className="continueBTN  btn-block mx-auto" onClick={()=>dashBoard()}>
              Go to Dashboard
            </button>
          </div>

  );
};

export default SuccessMessage;
